"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/gate/EventDispatcher");
var mobx_1 = require("mobx");
var helper_1 = require("lib/functions/helper");
var Model = (function () {
    function Model(gate, dataStore) {
        this.gate = gate;
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false)) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.getApiKeyBySlug = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/api/key/credentials", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            if (Object.keys(r.data).length > 0) {
                                this.json_data.api_key_user_id = r.data.userId;
                                this.json_data.api_key_profile_id = r.data.profileId;
                                this.json_data.profile = r.data.profile;
                                this.json_data.type = r.data.type;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_1 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getDataById = function (list, id) {
        var listIndexFound = list.findIndex(function (_a) {
            var itemId = _a.id;
            return itemId === id;
        });
        if (listIndexFound > -1) {
            return list[listIndexFound];
        }
        return [];
    };
    Model.prototype.getPrograms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, options, r, newPrograms, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/programs/" + campusId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newPrograms = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, description = _a.description;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + description
                                });
                            });
                            this.json_data.programs = newPrograms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_2 = _a.sent();
                        console.log("some error with getPrograms", error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getCareerPrograms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, options, campusFound, newPrograms;
            return __generator(this, function (_a) {
                try {
                    campusId = helper_1.getPartsByDelimiter(value)[0];
                    options = {
                        slug: process.env.SLUG
                    };
                    if (this.json_data.careersCampuses && this.json_data.careersCampuses.length > 0) {
                        campusFound = this.getDataById(this.json_data.careersCampuses, +campusId);
                        newPrograms = campusFound.programs.map(function (_a) {
                            var id = _a.id, name = _a.name, code = _a.code, description = _a.description;
                            return ({
                                name: name,
                                value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + description
                            });
                        });
                        this.json_data.careerPrograms = campusFound.programs;
                        this.json_data.programs = newPrograms;
                    }
                    this.dispatcher.dispatch();
                }
                catch (error) {
                    console.log("some error with getCareerPrograms", error);
                }
                return [2];
            });
        });
    };
    Model.prototype.getCampuses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, newCampuses, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/campuses", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            if (Object.keys(r.data).length > 0) {
                                newCampuses = r.data.map(function (_a) {
                                    var id = _a.id, name = _a.name, abbreviation = _a.abbreviation, checked = _a.checked;
                                    return ({
                                        name: name,
                                        value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + abbreviation + helper_1.DELIMITER + checked
                                    });
                                });
                                this.json_data.campuses = newCampuses;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_3 = _a.sent();
                        console.log("some error with getCampuses", error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getProgramVersions = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var programId, options, r, newProgramVersions, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        programId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/major-versions/" + programId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newProgramVersions = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, effectiveDate = _a.effectiveDate;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + effectiveDate
                                });
                            });
                            this.json_data.program_versions = newProgramVersions;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_4 = _a.sent();
                        console.log("some error with getProgramVersions", error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getCareerAcademicTracks = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var startingTermId, options, newStartingTermId, termFound, newAcademicShifts;
            return __generator(this, function (_a) {
                try {
                    startingTermId = helper_1.getPartsByDelimiter(value)[0];
                    options = {
                        slug: process.env.SLUG
                    };
                    if (this.json_data.careerStartingTerms &&
                        this.json_data.careerStartingTerms.length > 0) {
                        newStartingTermId = startingTermId !== "null" ? +startingTermId : null;
                        termFound = this.getDataById(this.json_data.careerStartingTerms, newStartingTermId);
                        newAcademicShifts = termFound.academicTracks.map(function (_a) {
                            var id = _a.id, name = _a.name, description = _a.description, programVersionId = _a.programVersionId;
                            return ({
                                name: name,
                                value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + description + helper_1.DELIMITER + programVersionId
                            });
                        });
                        this.json_data.careerAcademicTracks = termFound.academicTracks;
                        this.json_data.academic_shifts = newAcademicShifts;
                    }
                    this.dispatcher.dispatch();
                }
                catch (error) {
                    console.log("some error with getCareerAcademicTracks", error);
                }
                return [2];
            });
        });
    };
    Model.prototype.getAcademicTracks = function (campusValue, programValue) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, programId, options, r, newAcademicShifts, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = helper_1.getPartsByDelimiter(campusValue)[0];
                        programId = helper_1.getPartsByDelimiter(programValue)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/academic-shifts/" + campusId + "/" + programId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newAcademicShifts = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, isActive = _a.isActive, programVersionId = _a.programVersionId;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + isActive + helper_1.DELIMITER + programVersionId
                                });
                            });
                            this.json_data.academic_shifts = newAcademicShifts;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_5 = _a.sent();
                        console.log("some error with getProgramVersions", error_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.checkSingleLeadDistributionUser = function (json_data, step) {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG,
                            json_data: __assign(__assign({}, json_data), { acronym: process.env.ACRONYM_SLUG, slug: process.env.SLUG })
                        };
                        return [4, this.gate.request("/v3/submit/single-lead-distribution/" + step, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            if (Object.keys(r.data).length > 0) {
                                if (r.data.isUserEmailExist && r.data.redirectToSignIn) {
                                    this.json_data = __assign(__assign({}, this.json_data), { redirectToSignIn: r.data.redirectToSignIn });
                                }
                                else {
                                    this.json_data = r.data;
                                }
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_6 = _a.sent();
                        console.log("some error with checkSingleLeadDistributionUser:", error_6);
                        throw new Error("" + error_6);
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getStartingTermsByMajor = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var majorId, options, r, startingTerms, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        majorId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG,
                            completeMajorDetails: true
                        };
                        return [4, this.gate.request("/v3/terms/by-major/" + majorId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            startingTerms = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, start_date = _a.start_date, end_date = _a.end_date, major_id = _a.major_id, program_version_id = _a.program_version_id, academicTrackId = _a.academicTrackId, majorStartDate = _a.majorStartDate;
                                return ({
                                    name: "" + helper_1.formatStandarUSDate(majorStartDate),
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + start_date + helper_1.DELIMITER + end_date + helper_1.DELIMITER + major_id + helper_1.DELIMITER + program_version_id + helper_1.DELIMITER + academicTrackId + helper_1.DELIMITER + majorStartDate
                                });
                            });
                            this.json_data.startingTermList = startingTerms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_7 = _a.sent();
                        console.log("some error with getStartingTermsByMajor", error_7);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getCareerStartingTerms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var majorId, options, progamFound, startingTerms;
            return __generator(this, function (_a) {
                try {
                    majorId = helper_1.getPartsByDelimiter(value)[0];
                    options = {
                        slug: process.env.SLUG
                    };
                    if (this.json_data.careerPrograms && this.json_data.careerPrograms.length > 0) {
                        progamFound = this.getDataById(this.json_data.careerPrograms, +majorId);
                        startingTerms = progamFound.startingTerms.map(function (_a) {
                            var id = _a.id, name = _a.name, code = _a.code, start_date = _a.start_date, end_date = _a.end_date, major_id = _a.major_id, program_version_id = _a.program_version_id, academicTrackId = _a.academicTrackId, majorStartDate = _a.majorStartDate;
                            return ({
                                name: "" + helper_1.formatStandarUSDate(majorStartDate),
                                value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + start_date + helper_1.DELIMITER + end_date + helper_1.DELIMITER + major_id + helper_1.DELIMITER + program_version_id + helper_1.DELIMITER + academicTrackId + helper_1.DELIMITER + majorStartDate
                            });
                        });
                        this.json_data.careerStartingTerms = progamFound.startingTerms;
                        this.json_data.startingTermList = startingTerms;
                    }
                    this.dispatcher.dispatch();
                }
                catch (error) {
                    console.log("some error with getCareerStartingTerms", error);
                }
                return [2];
            });
        });
    };
    Model.prototype.getCareerUpcomingTermsCampuses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, newCampuses, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/admissions/upcoming-terms/careers", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            if (Object.keys(r.data).length > 0) {
                                newCampuses = r.data.map(function (_a) {
                                    var id = _a.id, code = _a.code, name = _a.name, address = _a.address;
                                    return ({
                                        name: name,
                                        value: "" + id + helper_1.DELIMITER + code + helper_1.DELIMITER + name + helper_1.DELIMITER + address
                                    });
                                });
                                this.json_data.careersCampuses = r.data;
                                this.json_data.campuses = newCampuses;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_8 = _a.sent();
                        console.log("some error with getUpcomingTermsCareerCampuses", error_8);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.sendOneTimePasswordEmailToUser = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG,
                            email: ("" + value).trim().toLowerCase()
                        };
                        return [4, this.gate.request("/v3/pin-code", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.json_data.pin_code = r.data;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_9 = _a.sent();
                        console.log("some error with sendOneTimePasswordEmailToUser", error_9);
                        throw new Error("" + error_9);
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.otpSignIn = function (_a) {
        var email = _a.email, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_10;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG,
                            email: email,
                            password: password
                        };
                        return [4, this.gate.request("/v3/otp/sign-in", {
                                data: options
                            })];
                    case 1:
                        r = _b.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data = __assign(__assign({}, r.data.json_data), this.json_data);
                            }
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_10 = _b.sent();
                        console.log("some error with signIn", error_10);
                        throw new Error("" + error_10);
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "user", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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